/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useContext } from 'react'

import { Tooltip, Grid, Typography, IconButton, Menu, MenuItem, TextField } from '@material-ui/core'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import axios from 'axios'
import { format } from 'date-fns'
import MUIDataTable from 'mui-datatables'
import { useHistory } from 'react-router-dom'

import FiltersStores from './FiltersStores'
import useStyles from './generalConfig.styles'
import ModalActiveStore from './ModalActiveStore'

import BackDrop from 'components/BackDrop'
import Button from 'components/CustomButtons/Button'
import { EyeIcon } from 'components/icons/personalizedIcons'
import TooltipsUpdateEmailSeller from 'components/TooltipsUpdateEmailSeller/TooltipsUpdateEmailSeller'
import useCustomDialogAlert from 'components/useCustomDialogAlert'
import { COMMERCIAL_ADVISOR } from 'constants/rolesConst'
import { routesLink } from 'constants/routesConsts'
import STORE_STATUS, {
  READY_TO_ACTIVATE_STATUS,
  ENROLLED_STATUS,
  APPROVEMENTS_MERCURIO_FILTER,
} from 'constants/storeConstants'
import { API_SELLERS } from 'constants/urls'
import useAuthContext from 'contextApi/AuthContext'
import {
  getEnlistedSellers,
  changeStoreStatus,
  updateEmailSellerById,
} from 'services/sellers/sellers.services'
import { ExportProducts } from 'utils/functions'
import textLabels from 'utils/MUIDataTableTextLabels'

const Stores = () => {
  const classes = useStyles()
  const history = useHistory()
  const [pagination, setPagination] = useState({
    page: 0,
    perPage: 10,
    prevPage: '',
    nextPage: '',
    typeFilter: 0,
  })
  const [optionsMenu, setOptionsMenu] = useState({
    actualState: null,
    options: [],
    idStore: null,
    sellerId: null,
    isUser: null,
    storeIdMercurio: null,
  })
  const { userLoggedin } = useContext(useAuthContext)
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [total, setTotal] = useState(0)
  const showDialogAlert = useCustomDialogAlert()
  const [openModalModel, setOpenModalModel] = useState(false)
  const [sellerToActive, setSellerToActive] = useState({ id: 0, idSeller: 0, isUser: false })
  const [selectedState, setSelectedState] = useState(0)
  const [showInputEmail, setShowInputEmail] = useState(false)
  const [rowAndColumSelectedEmail, setRowAndColumSelectedEmail] = useState({
    row: null,
    colum: null,
  })
  const [newEmail, setNewEmail] = useState(null)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const handleCloseModalModel = () => {
    setOpenModalModel(false)
  }

  const handleClose = async () => {
    setAnchorEl(null)
    setOpen(false)
  }

  const openDetailStore = (id) => {
    history.push(`${routesLink.storeDetail}/${id}`)
  }

  const openProducts = (idSeller) => {
    history.push(`${routesLink.productsBySeller}/${idSeller}`)
  }

  const getModels = async (
    searchText = '',
    selectedDateFrom = '01/01/0001 0:00:00',
    selectedDateTo = '01/01/0001 0:00:00',
    typeFilter,
    page,
    perPage
  ) => {
    setShowInputEmail(false)
    setIsLoading(true)

    if (userLoggedin.role === COMMERCIAL_ADVISOR) {
      getEnlistedSellers({
        pageNumber: pagination.page,
        pageSize: pagination.perPage,
        startDate: selectedDateFrom,
        endDate: selectedDateTo,
        searchText,
        sellerFilterType: typeFilter ?? pagination.typeFilter,
      })
        .then((response) => {
          if (response.status === 200) {
            setData(response.data.data)
            setTotal(response.data.pagination.totalCount)
            setPagination({
              ...pagination,
              page: response.data.pagination.pageNumber - 1,
              perPage: perPage !== undefined ? perPage : response.data.pagination.pageSize,
              typeFilter: typeFilter !== undefined ? typeFilter : pagination.typeFilter,
            })
          }
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      axios
        .get(
          `${API_SELLERS}?searchText=${searchText}&startDate=${selectedDateFrom}&endDate=${selectedDateTo}&sellerFilterType=${
            typeFilter !== undefined ? typeFilter : pagination.typeFilter
          }&pageSize=${perPage !== undefined ? perPage : pagination.perPage}&pageNumber=${
            page !== undefined ? page : pagination.page
          }`
        )
        .then((response) => {
          if (response.status === 200) {
            setData(response.data.data)
            setTotal(response.data.pagination.totalCount)
            setPagination({
              ...pagination,
              page: response.data.pagination.pageNumber - 1,
              perPage: perPage !== undefined ? perPage : response.data.pagination.pageSize,
              typeFilter: typeFilter !== undefined ? typeFilter : pagination.typeFilter,
            })
          }
          setIsLoading(false)
        })
        .catch(() => {
          setIsLoading(false)
        })
    }
  }

  const handleClickList = (
    event,
    idStore,
    sellerId,
    isUser,
    isActive,
    currentStatus,
    storeIdMercurio
  ) => {
    const response = {
      options: [],
      idStore: idStore,
      sellerId: sellerId,
      isUser: isUser,
      currentStatus,
      storeIdMercurio: storeIdMercurio,
    }
    const nextStatus = STORE_STATUS.find((status) => status.prevId === currentStatus)
    response.options = ['Ver productos', 'Ver tienda']
    if (
      selectedState !== APPROVEMENTS_MERCURIO_FILTER &&
      (currentStatus === READY_TO_ACTIVATE_STATUS || currentStatus === ENROLLED_STATUS)
    ) {
      if (!isActive) {
        response.options.push('Activar')
      } else if (!storeIdMercurio && isActive) {
        response.options.push('Desactivar')
      }
    } else if (!storeIdMercurio && userLoggedin.role !== COMMERCIAL_ADVISOR) {
      response.options.push(nextStatus.name)
    }

    setOptionsMenu(response)
    setAnchorEl(event.currentTarget)
    setOpen(true)
  }

  const activeStore = async (id, idSeller = 0, isUser = false, username = '') => {
    try {
      const tempData = {
        id: id,
        userName: username,
      }
      if (idSeller) {
        tempData.sellerId = idSeller
        tempData.isUser = isUser
      }
      setIsLoading(true)
      const result = await axios({
        url: `${API_SELLERS}/ActivateSeller`,
        method: 'post',
        data: tempData,
      })
      if (result) {
        if (result.status === 200) {
          setIsLoading(false)
          handleCloseModalModel()
          getModels('', '01/01/0001 0:00:00', '01/01/0001 0:00:00')
          showDialogAlert(
            true,
            '¡Cambio exitoso!',
            `La tienda se ha activado correctamente`,
            'Cerrar',
            '',
            true
          )
        }
      }
    } catch (error) {
      setIsLoading(false)
    }
  }
  const openActiveStore = (id, idSeller, isUser) => {
    if (isUser) {
      showDialogAlert(
        true,
        '¡Advertencia!',
        '¿Está seguro de volver a activar esta tienda?',
        'Confirmar',
        'Cancelar',
        false,
        () => activeStore(id, idSeller, isUser)
      )
    } else {
      setOpenModalModel(true)
      setSellerToActive({ id: id, idSeller: idSeller, isUser: isUser })
    }
  }
  const inactivateStores = async (id, email) => {
    setIsLoading(true)
    try {
      const result = await axios({
        url: `${API_SELLERS}/DeactivateUser?sellerId=${id}&Email=${email}`,
        method: 'get',
      })
      if (result) {
        if (result.status === 200) {
          setIsLoading(false)
          showDialogAlert(
            true,
            '¡Cambio exitoso!',
            `La tienda se ha inactivado correctamente`,
            'cerrar',
            '',
            true
          )
          getModels()
        }
      }
    } catch (error) {
      setIsLoading(false)
    }
  }

  const confirmInactivateStore = (id, email) => {
    showDialogAlert(
      true,
      '¡Advertencia!',
      `Está seguro de inactivar esta Tienda?, todos los usuarios asociados serán inactivados.`,
      'Confirmar',
      'Cancelar',
      false,
      () => inactivateStores(id, email)
    )
  }

  const modifyStoreStatus = (sellerId, currentStatus, newStatus) => {
    setIsLoading(true)
    changeStoreStatus(sellerId, currentStatus.filterType, newStatus.filterType)
      .then((result) => {
        if (result.status === 200) {
          getModels()
          showDialogAlert(
            true,
            '¡Cambio exitoso!',
            `La tienda se ha movido de ${currentStatus.name} a ${newStatus.name}`,
            'Cerrar',
            '',
            true
          )
        } else {
          showDialogAlert(
            true,
            '¡Error!',
            'Ocurrió un error al cambiar el estado de la tienda',
            'Cerrar',
            '',
            true
          )
        }
      })
      .catch(() => {
        showDialogAlert(
          true,
          '¡Error!',
          'Ocurrió un error al cambiar el estado de la tienda',
          'Cerrar',
          '',
          true
        )
      })
      .finally(() => {
        setIsLoading(false)
      })
  }
  const isValidEmail = (email) => {
    const regex = /^[a-zA-Z0-9](\.?[a-zA-Z0-9_-])*@[a-zA-Z0-9_-]+(\.[a-zA-Z]{2,})+$/
    return regex.test(email)
  }
  const updateEmailSeller = (id, email) => {
    setIsLoading(true)
    updateEmailSellerById(id, email)
      .then((response) => {
        if (response.status === 200) {
          getModels('', '01/01/0001 0:00:00', '01/01/0001 0:00:00', pagination.typeFilter)
          setShowInputEmail(false)
          showDialogAlert(false)
        }
        setIsLoading(false)
      })
      .catch(() => {
        setIsLoading(false)
        showDialogAlert(
          true,
          '¡Advertencia!',
          'El correo electrónico no es válido o ya está en uso.',
          'Aceptar'
        )
      })
  }
  const validationEmail = (id, email, oldEmail) => {
    const next = (newEmail ?? '').trim()
    const prev = (oldEmail ?? '').trim()
    if (!next) {
      showDialogAlert(true, '¡Advertencia!', `El nuevo email está vacío.`, 'Aceptar')
      return
    }
    if (!isValidEmail(next)) {
      showDialogAlert(true, '¡Advertencia!', `El nuevo email no tiene formato válido.`, 'Aceptar')
      return
    }
    if (next.toLowerCase() === prev.toLowerCase()) {
      showDialogAlert(
        true,
        '¡Advertencia!',
        `El nuevo email no puede ser igual al anterior.`,
        'Aceptar'
      )
      return
    }
    showDialogAlert(
      true,
      '¡Advertencia!',
      `Está seguro que desera cambiar el email de la tienda.`,
      'Confirmar',
      'Cancelar',
      false,
      () => updateEmailSeller(id, email)
    )
  }
  const selectOption = async (option, idStore, sellerId, isUser, email, currentStatusId) => {
    const nextStatus = STORE_STATUS.find((status) => status.prevId === currentStatusId)
    const currentStatus = STORE_STATUS.find((status) => status.id === currentStatusId)
    switch (option) {
      case 'Exportar productos':
        await ExportProducts(idStore)
        break
      case 'Ver tienda':
        openDetailStore(idStore)
        break
      case 'Ver productos':
        openProducts(sellerId)
        break
      case 'Activar':
        openActiveStore(idStore, sellerId, isUser)
        break
      case 'Desactivar':
        confirmInactivateStore(sellerId, email)
        break
      case nextStatus.name:
        await modifyStoreStatus(idStore, currentStatus, nextStatus)
        break
      default:
        break
    }
  }

  const columns = [
    {
      name: 'id',
      options: { display: false },
    },
    {
      name: 'sellerId',
      options: { display: false },
    },
    {
      name: 'isUser',
      options: { display: false },
    },
    {
      name: 'email',
      label: 'Email de la tienda ',
      options: {
        customHeadLabelRender: () => {
          return (
            <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
              EMAIL DE LA TIENDA
            </th>
          )
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <div className={classes.editEmail} style={{ width: '100%' }}>
              {showInputEmail &&
              tableMeta.rowIndex === rowAndColumSelectedEmail.row &&
              rowAndColumSelectedEmail.colum === 3 ? (
                <TextField
                  value={newEmail}
                  style={{ width: '100%' }}
                  onChange={(e) => {
                    setNewEmail(e.target.value)
                  }}
                />
              ) : (
                <p>{value}</p>
              )}
              <TooltipsUpdateEmailSeller
                updateEmailSeller={validationEmail}
                tableMeta={tableMeta}
                newEmail={newEmail}
                setRowAndColumSelectedEmail={setRowAndColumSelectedEmail}
                rowAndColumSelectedEmail={rowAndColumSelectedEmail}
                setShowInputEmail={setShowInputEmail}
                showInputEmail={showInputEmail}
                setNewEmail={setNewEmail}
                value={value}
              />
            </div>
          )
        },
      },
    },
    {
      name: 'userName',
      label: 'Nombre de usuario ',
      options: {
        customHeadLabelRender: () => {
          return (
            <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>NOMBRE DE USUARIO</th>
          )
        },
        customBodyRender: (value, tableMeta) => {
          return (
            <div className={classes.editEmail} style={{ width: '100%' }}>
              {showInputEmail &&
              tableMeta.rowIndex === rowAndColumSelectedEmail.row &&
              rowAndColumSelectedEmail.colum === 4 ? (
                <TextField
                  value={newEmail}
                  style={{ width: '100%' }}
                  onChange={(e) => {
                    setNewEmail(e.target.value)
                  }}
                />
              ) : (
                <p>{value}</p>
              )}
              <TooltipsUpdateEmailSeller
                updateEmailSeller={updateEmailSeller}
                tableMeta={tableMeta}
                newEmail={newEmail}
                setRowAndColumSelectedEmail={setRowAndColumSelectedEmail}
                rowAndColumSelectedEmail={rowAndColumSelectedEmail}
                setShowInputEmail={setShowInputEmail}
                showInputEmail={showInputEmail}
                setNewEmail={setNewEmail}
                value={value}
              />
            </div>
          )
        },
      },
    },
    {
      name: 'name',
      label: 'Nombre de la tienda ',
      options: {
        customHeadLabelRender: () => {
          return (
            <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
              NOMBRE DE LA TIENDA
            </th>
          )
        },
      },
    },
    {
      name: 'createdOn',
      label: 'Fecha de registro',
      options: {
        customHeadLabelRender: () => {
          return (
            <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>FECHA DE REGISTRO</th>
          )
        },
        customBodyRender: (value) => {
          return format(new Date(value), 'yyyy-MM-dd')
        },
      },
    },
    {
      name: 'isActive',
      options: {
        display: false,
      },
    },

    {
      name: 'statusName',
      label: 'Estado ',
      options: {
        customHeadLabelRender: () => {
          return <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>ESTADO</th>
        },
        customBodyRender: (value, tableMeta) => {
          const statusName =
            tableMeta.rowData[11] !== ENROLLED_STATUS
              ? value
              : tableMeta.rowData[7]
              ? 'Activo'
              : 'Inactivo'
          return <>{statusName}</>
        },
      },
    },
    {
      name: 'storeId',
      label: 'Origen ',
      options: {
        customHeadLabelRender: () => {
          return <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>ORIGEN</th>
        },
        customBodyRender: (value, tableMeta) => {
          const originName = tableMeta.rowData[9] === null ? 'Luegopago' : 'Sistecrédito'
          return <>{originName}</>
        },
      },
    },
    {
      name: '',
      label: '',
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <Tooltip title="Ver">
                <IconButton
                  className={classes.iconEye}
                  onClick={(event) => {
                    event.preventDefault()
                    history.push(`${routesLink.storeDetail}/${tableMeta.rowData[0]}`)
                  }}
                >
                  <EyeIcon />
                </IconButton>
              </Tooltip>
              {userLoggedin.role !== COMMERCIAL_ADVISOR && (
                <>
                  <IconButton
                    onClick={(event) => {
                      handleClickList(
                        event,
                        tableMeta.rowData[0],
                        tableMeta.rowData[1],
                        tableMeta.rowData[2],
                        tableMeta.rowData[7],
                        tableMeta.rowData[11],
                        tableMeta.rowData[9]
                      )
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <div>
                    <Menu
                      id="long-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          width: '38ch',
                          boxShadow: '-6px 6px #E8E8E8',
                          fontFamily: 'Red Hat Display Regular',
                        },
                      }}
                    >
                      {optionsMenu &&
                        optionsMenu?.options.map((option) => (
                          <MenuItem
                            selected={option === 'Pyxis'}
                            onClick={(event) => {
                              event.preventDefault()
                              const storeSelect = tableMeta?.tableData?.find(
                                (store) => store[0] === optionsMenu.idStore
                              )
                              selectOption(
                                option,
                                optionsMenu.idStore,
                                optionsMenu.sellerId,
                                optionsMenu.isUser,
                                storeSelect[3],
                                optionsMenu.currentStatus
                              )
                            }}
                            style={{ fontFamily: 'Red Hat Display Regular' }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                    </Menu>
                  </div>
                </>
              )}
            </>
          )
        },
      },
    },
    {
      name: 'statusId',
      options: { display: false },
    },
  ]

  useEffect(() => {
    getModels()
  }, [])

  const changePageTable = (paginationpage) => {
    let pageInt = Number(paginationpage) + 1
    if (paginationpage === 1 && paginationpage === pagination.page) {
      pageInt = 1
    }
    setPagination({
      ...pagination,
      page: pageInt - 1,
      prevPage: pageInt - 1,
      nextPage: pageInt + 1,
    })
    getModels('', '01/01/0001 0:00:00', '01/01/0001 0:00:00', pagination.typeFilter, pageInt)
  }

  const changePerPagetable = (perPage) => {
    setPagination({ ...pagination, perPage: perPage })
    getModels(
      '',
      '01/01/0001 0:00:00',
      '01/01/0001 0:00:00',
      pagination.typeFilter,
      pagination.page,
      perPage
    )
  }

  const setResultadosVentanaBusqueda = (results) => {
    setData(results)
  }

  const options = {
    print: false,
    search: false,
    filter: false,
    sort: false,
    download: false,
    viewColumns: false,
    page: pagination.page,
    serverSide: true,
    responsive: 'scrollMaxHeight',
    selectableRows: 'none',
    textLabels,
    count: total,
    rowsPerPageOptions: [10, 15, 100],
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePageTable(tableState.page === 0 ? 1 : tableState.page)
          document.querySelector('#main').scrollTop = 0
          break
        case 'changeRowsPerPage':
          changePerPagetable(tableState.rowsPerPage)
          break
        default:
          break
      }
    },
  }

  return (
    <>
      <Grid container justifyContent="space-between" className={classes.titleStores}>
        <Typography variant="h6">Tiendas</Typography>
        {userLoggedin.role === COMMERCIAL_ADVISOR && (
          <Button
            className={classes.button}
            onClick={() => {
              history.push(`${routesLink.storeEnlistment}`)
            }}
          >
            Registrar tienda
          </Button>
        )}
      </Grid>

      <Grid container direction="column" className={classes.divContent}>
        <BackDrop open={isLoading} />
        <FiltersStores
          getModels={getModels}
          setResultadosVentanaBusqueda={setResultadosVentanaBusqueda}
          showApprovements={userLoggedin.role !== COMMERCIAL_ADVISOR}
          selectedState={selectedState}
          setSelectedState={setSelectedState}
        />
        <BackDrop open={isLoading} />
        {openModalModel && (
          <ModalActiveStore
            sellerToActive={sellerToActive}
            activeStore={activeStore}
            getSellers={getModels}
            onCancel={handleCloseModalModel}
          />
        )}
        <MUIDataTable data={data} columns={columns} options={options} />
      </Grid>
    </>
  )
}

export default Stores
